type LoadingSpinnerProps = {
  size?: 'sm' | 'md' | 'lg';
  className?: string;
};

const LoadingSpinner = ({ size = 'md', className = '' }: LoadingSpinnerProps) => {
  const sizeClasses = {
    sm: 'w-4 h-4',
    md: 'w-8 h-8',
    lg: 'w-12 h-12',
  };

  return (
    <div className="h-screen flex items-center justify-center">
      <div className="text-center">
        <div
          className={`${sizeClasses[size]} animate-spin rounded-full border-4 border-gray-200 border-t-[#16783a] mx-auto ${className}`}
        />
        <p className="text-gray-600 mt-4">Loading...</p>
      </div>
    </div>
  );
};

export default LoadingSpinner;
